export var Status;
(function (Status) {
    Status["success"] = "success";
    Status["fail"] = "fail";
})(Status || (Status = {}));
export var Choice;
(function (Choice) {
    Choice["yes"] = "yes";
    Choice["no"] = "no";
})(Choice || (Choice = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdHVzLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbImNvbnN0YW50cy9zdGF0dXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFOLElBQVksTUFHWDtBQUhELFdBQVksTUFBTTtJQUNoQiw2QkFBbUIsQ0FBQTtJQUNuQix1QkFBYSxDQUFBO0FBQ2YsQ0FBQyxFQUhXLE1BQU0sS0FBTixNQUFNLFFBR2pCO0FBRUQsTUFBTSxDQUFOLElBQVksTUFHWDtBQUhELFdBQVksTUFBTTtJQUNoQixxQkFBVyxDQUFBO0lBQ1gsbUJBQVMsQ0FBQTtBQUNYLENBQUMsRUFIVyxNQUFNLEtBQU4sTUFBTSxRQUdqQiJ9